import { Component, HostBinding, Input, Output, EventEmitter, inject, signal, Type } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { animate, state, style, transition, trigger } from "@angular/animations";

import { CommonModule } from "@angular/common";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { NavItem } from "../../../../core/models/nav-item.model";
import { NavService } from "../../../../core/services/nav.service";
import { EzBaseComponent } from "@template-ui/components/ez-base.component";
import { AppRoutePrefixService } from "@app/core/services/app-route-prefix.service";

export type NavItemWithEvent = {navItem: NavItem, event: MouseEvent};

/**
 * MenuItemComponent
 * This represents a single menu item in a Material Nav List
 */
@Component({
    selector: "app-side-menu-item",
    imports: [CommonModule, MatListModule, MatIconModule, RouterModule],
    templateUrl: "./side-menu-item.component.html",
    styleUrls: ["./side-menu-item.component.scss"],
    animations: [
        trigger("indicatorRotate", [state("collapsed", style({ transform: "rotate(270deg)" })), state("expanded", style({ transform: "rotate(360deg)" })), transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4,0.0,0.2,1)"))]),
    ]
})
export class SideMenuItemComponent extends EzBaseComponent{
  private readonly appRoutePrefix = inject(AppRoutePrefixService);

  private _expanded?: boolean;
  get expanded(): boolean {
    if (this._expanded != undefined) {
      return this._expanded;
    }

    return (this._expanded = this.item?.hasChildren && this.item.isAlongActivatedRoute) || false;
  }

  set expanded(expanded: boolean) {
    this._expanded = this.ariaExpanded = expanded;
  }

  @HostBinding("attr.aria-expanded") ariaExpanded: any;
  @Output() nav = new EventEmitter<NavItemWithEvent>();
  @Input() public item!: NavItem;
  @Input() depth: number = 0;

  navService = inject(NavService);


  constructor() {

    super();

    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  protected isRouterItem(menuItem: NavItem): boolean {
    return menuItem.isThisApp || this.appRoutePrefix.isAppRoute(menuItem.route);
  }

  protected routerLinkFor(menuItem: NavItem): string | null {
    return this.appRoutePrefix.stripRoutePrefix(menuItem.route);
  }

  protected itemHasAppRouteChildren(menuItem: NavItem): boolean {
    if(menuItem.hasChildren)
    {
      return menuItem.children?.some(mi => this.isRouterItem(mi)) || false;
    }

    // Should never happen cuz this should only be called on items with children
    return false;
  }

  onItemSelected(event: MouseEvent, menuItem: NavItem) {

    // For now, don't prevent default, let it go.
    // event.preventDefault();
    if (menuItem.hasChildren) {
      this.expanded = !this.expanded;
    } else {
      //this.onNav(menuItem);
      this.nav.emit({navItem: menuItem, event: event});
    }
  }

  onNav(menuItem: NavItem): void {
    // bubble up the event from the child item
    //this.layoutService.commissionerSelectedId = 0;
    //this.nav.emit(menuItem);
  }
}
